import { useQuery } from '@tanstack/react-query';
import { marketing } from '@/lib/supabase/marketing';

export interface LinkedinDaily {
  date: string;
  impressions: number | null;
  clicks: number | null;
  likes: number | null;
  comments: number | null;
  shares: number | null;
  engagement_rate_pct: number | null;
  new_followers: number | null;
  ad_spend: number | null;
  ad_impressions: number | null;
  ad_clicks: number | null;
  ad_conversions: number | null;
}

export interface LinkedinSnapshot {
  snapshot_date: string;
  followers_count: number | null;
}

export function useLinkedinDaily() {
  return useQuery({
    queryKey: ['linkedin-daily'],
    queryFn: async (): Promise<LinkedinDaily[]> => {
      const { data, error } = await marketing
        .from('linkedin_daily')
        .select('*')
        .order('date', { ascending: true });
      if (error) throw error;
      return (data ?? []) as unknown as LinkedinDaily[];
    },
    staleTime: 5 * 60_000,
  });
}

export function useLinkedinSnapshot() {
  return useQuery({
    queryKey: ['linkedin-snapshot'],
    queryFn: async (): Promise<LinkedinSnapshot | null> => {
      const { data, error } = await marketing
        .from('linkedin_snapshot')
        .select('*')
        .order('snapshot_date', { ascending: false })
        .limit(1);
      if (error) throw error;
      return ((data ?? [])[0] ?? null) as unknown as LinkedinSnapshot | null;
    },
    staleTime: 5 * 60_000,
  });
}
